import { FloatingPortal } from '@floating-ui/react';
import { ResetContext } from '../../context/ResetContext';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FloatingPortalWrapper(props) {
  return /*#__PURE__*/_jsx(ResetContext, {
    children: /*#__PURE__*/_jsx(FloatingPortal, Object.assign({}, props))
  });
}